import { Component, Input, inject } from '@angular/core';
import { UtilService } from '../../../../services/util.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TranslatorService } from '../../../../services/translator_service';
import moment from 'moment';

@Component({
  selector: 'app-contracts-table',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './contracts-table.component.html',
  styleUrl: './contracts-table.component.scss'
})
export class ContractsTableComponent {

  private _data: any[] = [];
  activeContract = 0;
  currentLang;

  constructor(private translator: TranslatorService, private utilService: UtilService) {
    this.currentLang = this.translator.translate.currentLang || 'en';
    this.translator.currentLangEmitter$.subscribe((lang: any) => {
      this.currentLang = lang;
    });
  }

  isLoading = true;

  @Input() set data(value: any[]) {
    this._data = value;
    if (value?.length) {
      this.isLoading = false;
      this.activeContract = 0;
    }
  }
  get data(): any[] { return this._data; }

  get selected(): any { return this._data[this.activeContract] || {}; }

  get activeSince(): string {
    const createdDate = this.selected.created_date;
    if (!createdDate) { return ''; }
    return moment(createdDate).format(this.currentLang == 'iw' ? 'DD/MM/YYYY' : 'MM/DD/YYYY');
  }

  get currentBilling(): string {
    const contract = this.selected;
    let total = 0;
    for (const site of (contract.sites || [])) {
      for (const bin of (site.bins || [])) {
        for (const event of (bin.events || [])) {
          total += event.rate || 0;
        }
      }
    }
    const firstEt = (contract.event_types || [])[0];
    const currency = firstEt ? (this.isHebrew ? firstEt.contract_currency_type_name_hebrew : firstEt.contract_currency_type_name) : '';
    return `${this.utilService.roundAmount(total)} ${currency}`.trim();
  }

  get isHebrew(): boolean { return this.currentLang == 'iw'; }

  eventTypeName(et: any): string {
    return this.isHebrew ? et.event_type_name_hebrew : et.event_type_name;
  }

  eventTypeValue(et: any): string {
    const currency = this.isHebrew ? et.contract_currency_type_name_hebrew : et.contract_currency_type_name;
    return `${this.utilService.roundAmount(et.rate)} ${currency}`;
  }
}
